import { ClipExport } from "./ClipExport";
import { ClipCreator } from "./ClipCreator";
import { SlicingModeType } from "./SlicingMode";
import { AudioMath } from "../../../../../../library-js/audio/AudioMath";

export class Slicing
{
  exporter:ClipCreator;

  async slice():Promise<void>
  {
    console.log( "Slicing >> ", "Mode:", SlicingModeType[ this.exporter.settings.slicing.type.value ] );

    console.log( "Slicing Settings", this.exporter.settings );

    switch ( this.exporter.settings.slicing.type.value )
    {
      case SlicingModeType.NoSlicing:{ this._noSlice(); } break;
      case SlicingModeType.Beats:    { this._sliceBeats(); } break;
      case SlicingModeType.Duration: { this._sliceDuration(); } break;
      case SlicingModeType.Division: { this._sliceDivision(); } break;
    }

    return Promise.resolve();
  } 

  _noSlice()
  {
    this.exporter.settings.exports.clear();
    
    let duration = this.exporter.editor.project.audioBuffer.duration;

    this.exporter.settings.exports.add( ClipExport.create( 0, duration ) );
  }

  _sliceClipsWith( clipDuration:number )
  {
    let totalDuration = this.exporter.editor.project.audioBuffer.duration;
    let numClips = Math.ceil( totalDuration / clipDuration ); 

    console.log( "Slicing per duration", { clipDuration, totalDuration, numClips } );

    let offset = 0;

  

    for ( let i = 0; i < numClips; i++ )
    {
      let start = offset;
      let end   = Math.min( totalDuration, start + clipDuration );
      
      let clip = ClipExport.create( start, end );

      if ( clip.duration >= clipDuration * 0.9 )
      {
        this.exporter.settings.exports.add( clip );
        offset += clipDuration;
      }
         
    } 
  }

  _sliceDuration()
  {
    this.exporter.settings.exports.clear();

    let duration = this.exporter.settings.slicing.durationSlicingOptions.duration;

    this._sliceClipsWith( duration );

    return Promise.resolve();

  }

  

  _sliceBeats()
  {
    this.exporter.settings.exports.clear();

    let bpm   = this.exporter.settings.slicing.beatsSlicingOptions.bpm;
    let beats = this.exporter.settings.slicing.beatsSlicingOptions.beats;

    let duration = AudioMath.beatsToSeconds( beats, bpm );

    this._sliceClipsWith( duration );

    return Promise.resolve();
  } 

  

  _sliceDivision()
  {
    this.exporter.settings.exports.clear();

    let duration = this.exporter.editor.project.audioBuffer.duration / this.exporter.settings.slicing.divisionSlicingOptions.divisions;

    this._sliceClipsWith( duration );

    return Promise.resolve();
  }
}